<template>
    <div id="testimonials" class="section">
        <span v-if="language==='EN'">
            <PageTitle :title="'Comment Page'" :subtitle="'PLEASE LEAVE YOUR COMMENT HERE'" :description="''" />
                <Testimonials :testimonials="Testimonials_EN" />
                <p>Add comments:</p>
        </span>
        <span v-if="language==='RU'">
            <PageTitle :title="'Отзывы и комментарии'" :subtitle="'ВЫ МОЖЕТЕ ОСТАВИТЬ ОТЗЫВ И КОММЕНТАРИЙ ЗДЕСЬ'" :description="''" />
                <Testimonials :testimonials="Testimonials_RU" />                          
                <p>Добавить коментарий:</p>
        </span>
        <span v-if="language==='UA'">
            <PageTitle :title="'Коментарi та вiдгуки'" :subtitle="'БУДЬ ЛАСКА, ЗАЛИШТЕ КОМЕНТАРІ ТУТ'" :description="''" />
                <Testimonials :testimonials="Testimonials_UA" />           
                <p>Додати коментар:</p>
        </span>

        <br><br>
     <div class="text-xs-justyfy">
        <div class="fb-comments" data-href="http://oksana-kowcz.com/" data-width="700" data-numposts="5" data-colorscheme="light"></div>
    </div>
    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle'
    import { MyFunctions } from '@/data/functions.js'
    import  testimonials_en from '@/data/testimonials_EN.json' 
    import  testimonials_ru from '@/data/testimonials_RU.json'
    import  testimonials_ua from '@/data/testimonials_UA.json'           
    import Testimonials from '@/components/testimonials/Testimonials'

    export default {
        components: { PageTitle, Testimonials },
        data: () => ({
            language: '',
            Testimonials_EN: null,
            Testimonials_RU: null,
            Testimonials_UA: null, 
        }),
        created(){
            this.getTestimonials()
        },
        mounted(){
            this.language = MyFunctions.getLanguage()
        },
        methods: {
            getTestimonials(){
                this.Testimonials_EN = testimonials_en
                this.Testimonials_RU = testimonials_ru
                this.Testimonials_UA = testimonials_ua                                
            }
        }
    }
</script>

<style>
    #testimonials p {
        color: #666!important;
    }
    #testimonials .title {
        color: #000!important;
    }
</style>
